import Icon from '@material-ui/icons/Bookmark';
import React from 'react';
import { CreateButton } from '../../../../buttons';
import { EditDialog, Filter, ResourceList, ResourceShow } from '../../../../controllers';
import { LinkField, TextField } from '../../../../fields';
import { BooleanInput, ReferenceInput, SearchInput, TextInput } from '../../../../inputs';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <ReferenceInput
          source="library_keyring_id"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        fixedValue={{ library_object_constant_id: props.parentResource.id }}
        {...props}
      >
        <TextInput
          source="value"
        />
        <ReferenceInput
          source="library_keyring_id"
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="value"
        />
        <LinkField
          source="library_keyring_id"
          allowEmpty
        />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TextField
          source="value"
        />
        <LinkField
          source="library_keyring_id"
          allowEmpty
        />
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <SearchInput
          label="Search"
          source="q"
        />
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
